var _react_refresh_temp_1;
import { jsx as _jsx } from "react/jsx-runtime";
import { C } from '#integrations';
import { Box } from '../Box';
import { IconBackgroundTestIdFactory } from './interactions/IconBackground.interactions';
import styles from './IconBackground.module.css';
const ICON_BACKGROUND_SIZES = {
    large: 'large',
    medium: 'medium',
    small: 'small',
};
const COLOR_CLASS_MAP = {
    grey: styles.Grey,
    red: styles.Red,
    orange: styles.Orange,
    green: styles.Green,
    indigo: styles.Indigo,
    pink: styles.Pink,
};
const ICON_BACKGROUND_SIZE_TO_ICON_SIZE_MAP = {
    [ICON_BACKGROUND_SIZES.large]: 'large',
    [ICON_BACKGROUND_SIZES.medium]: 'xsmall',
    [ICON_BACKGROUND_SIZES.small]: 'xxsmall',
};
const SIZE_CLASS_MAP = {
    large: styles.Large,
    medium: styles.Medium,
    small: styles.Small,
};
export const IconBackground = ({ color = 'grey', 'data-testid': testid, Icon, size = 'medium', }) => {
    return (_jsx(Box, { align: "center", className: C(COLOR_CLASS_MAP[color], SIZE_CLASS_MAP[size]), "data-testid": IconBackgroundTestIdFactory.getIconBackgroundTestId(testid), justify: "center", radius: size === 'large' ? 'm' : 's', shrink: 0, children: _jsx(Icon, { color: color === 'grey' ? 'accent' : 'inverted', size: ICON_BACKGROUND_SIZE_TO_ICON_SIZE_MAP[size] }) }));
};
_react_refresh_temp_1 = IconBackground;
$RefreshReg$(_react_refresh_temp_1, "IconBackground");
